import { makeStyles } from '@material-ui/core';

const useStyles = makeStyles((theme) => ({
  root: {
    borderRadius: '10px',
    textTransform: 'inherit',
    minHeight: '62px',
    margin: '.6rem 0',
    boxShadow: '0 3px 15px rgba(0, 0, 0, 0.1)',
    //minWidth: '260px',
    width: '100%',
    '&:hover': {
      boxShadow: 'none',
    },
  },
  disabled: {
    pointerEvents: 'none',
    opacity: '.5',
  },
  labelWhite: { ...theme.labelButton, color: 'white' },
  labelGreen: {
    ...theme.labelButton,
    color: '#7cc4ac',
    '&:hover': { color: 'white' },
  },
  labelDark: {
    ...theme.labelButton,
    color: '#262957',
    '&:hover': { color: '#262957' },
  },
  labelRed: {
    ...theme.labelButton,
    color: theme.palette.secondary.main,
    '&:hover': {
      color: 'white',
    },
  },
  labelGrey: { ...theme.labelButton, color: '#868686' },

  backgroundWhite: {
    backgroundColor: 'white',
    '&:hover': {
      backgroundColor: theme.palette.primary.main,
      color: 'white',
    },
  },
  backgroundGrey: {
    backgroundColor: 'white',
    //'&:hover': { backgroundColor: '#7cc4ac' },
  },
  backgroundBlue: {
    backgroundColor: '#5ac8f5',
    '&:active, &:hover': {
      backgroundColor: theme.palette.primary.main,
      color: '#fff',
    },
  },
  backgroundWhiteCookies: {
    backgroundColor: 'white',
    color: '#262957',
    '&:hover': {
      backgroundColor: '#fff',
      color: '#262957',
      animation: `$cookieWhite 1s ease-in-out`,
    },
  },
  backgroundGreenCookies: {
    backgroundColor: '#fff',
    '&:hover': {
      backgroundColor: '#fff',
      color: '#7cc4ac',
      animation: `$cookieGreen 1s ease-in-out`,
    },
  },

  radius33: { borderRadius: '33px' },
  borderDark: { border: ' 1px solid rgba(38, 41, 87, 0.5)' },
  borderGreen: { border: '1px solid #7cc4ac' },
  disabledHover: {
    '&:hover': {
      backgroundColor: 'white',
      boxShadow: '0 3px 15px rgba(0, 0, 0, 0.1)',
      color: '#262957',
    },
  },
  '@keyframes cookieGreen': {
    '0%': {
      backgroundColor: '#fff',
      color: '#7cc4ac',
    },
    '10%': {
      backgroundColor: '#7cc4ac',
      color: '#fff',
    },
    '90%': {
      backgroundColor: '#7cc4ac',
      color: '#fff',
    },
    '100%': {
      backgroundColor: '#fff',
      color: '#7cc4ac',
    },
  },

  '@keyframes cookieWhite': {
    '0%': {
      backgroundColor: '#fff',
      color: '#262957',
    },
    '10%': {
      backgroundColor: '#262957',
      color: '#fff',
    },
    '90%': {
      backgroundColor: '#262957',
      color: '#fff',
    },
    '100%': {
      backgroundColor: '#fff',
      color: '#262957',
    },
  },
}));

export default useStyles;
